module.exports = __webpack_public_path__ + "img/x.2a446546.svg";